import React from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  TelegramShareButton,
  TelegramIcon,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

import { Container } from "./styles";

interface OwnProps {
  link: string;
  titulo: string;
}

type Props = OwnProps;

const Share: React.FC<Props> = ({ link, titulo }: Props) => {
  return (
    <Container>
      <WhatsappShareButton url={link}>
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
      <FacebookShareButton url={link} quote={titulo}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>
      <LinkedinShareButton url={link}>
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>
      <TwitterShareButton url={link}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>
      <TelegramShareButton url={link}>
        <TelegramIcon size={32} round />
      </TelegramShareButton>
    </Container>
  );
};

export default Share;
